var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { NotificationSource } from "../NotificationService.js";
import logger from "./Logger.js";
import { TelemetryExceptionName } from "../MSALAuthService/TelemetryExceptionName.js";
import EnvironmentService from "../EnvironmentService.js";
class PopupLogProvider {
  constructor(NotificationService2) {
    __publicField(this, "service");
    this.service = NotificationService2;
  }
  warn(event) {
    logger.trackMetric({
      name: "PopupLogProvider:Warn",
      average: performance.now(),
      properties: event
    });
    this.service.warn(event);
  }
  error(event) {
    if (EnvironmentService.disableMsalInPopupLogProvider() && (event == null ? void 0 : event.message) === TelemetryExceptionName.Core_MSALAuthContext_trackError) {
    } else {
      logger.trackMetric({
        name: "PopupLogProvider:Error",
        average: performance.now(),
        properties: event
      });
      if (event === void 0 || !event.properties || !event.properties["suppressPopup"]) {
        this.service.error(NotificationSource.popupLogProvider, event);
      }
    }
  }
  exception(error) {
    const _a = error.error, { message, name, stack } = _a, otherParams = __objRest(_a, ["message", "name", "stack"]);
    const props = __spreadValues(__spreadValues({
      name,
      stack
    }, otherParams), error.properties);
    this.error({ message, properties: props });
  }
}
export {
  PopupLogProvider
};
//# sourceMappingURL=PopupLogProvider.js.map
